import { gql } from "@apollo/client";

export const GET_BEHAVIORS_QUERY = gql`
  query BehaviorsList($searchKey: String!) {
    behaviorsList(searchKey: $searchKey) {
      pageData {
        id
        name
        description
        createdAt
      }
    }
  }
`;
